import React from 'react';

const s = {
  page: { width: '210mm', minHeight: '297mm', padding: '10mm 12mm', fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", fontSize: '9px', color: '#1a1a1a', lineHeight: '1.35', background: '#fff' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', borderBottom: '3px solid #0f172a', paddingBottom: '8px', marginBottom: '10px' },
  companyName: { fontSize: '20px', fontWeight: '800', color: '#0f172a', letterSpacing: '2px' },
  companySubtitle: { fontSize: '8px', color: '#64748b', marginTop: '1px' },
  docTitle: { fontSize: '13px', fontWeight: '700', color: '#0f172a', textAlign: 'right' },
  sectionTitle: { fontSize: '10px', fontWeight: '700', color: '#0f172a', textTransform: 'uppercase', letterSpacing: '1px', borderBottom: '1.5px solid #cbd5e1', paddingBottom: '3px', marginBottom: '6px', marginTop: '12px' },
  infoGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '4px 14px' },
  lbl: { fontSize: '7px', fontWeight: '600', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.5px' },
  val: { fontSize: '9px', fontWeight: '500', color: '#1e293b' },
  valBold: { fontSize: '9px', fontWeight: '700', color: '#0f172a' },
  valMono: { fontSize: '9px', fontWeight: '600', color: '#0f172a', fontFamily: 'monospace' },
  table: { width: '100%', borderCollapse: 'collapse', marginTop: '4px', fontSize: '8px' },
  th: { background: '#0f172a', color: '#fff', padding: '4px 5px', textAlign: 'left', fontSize: '7px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' },
  td: { padding: '4px 5px', borderBottom: '1px solid #e2e8f0', verticalAlign: 'top' },
  tdMono: { fontFamily: 'monospace', fontWeight: '600' },
  sigArea: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '20px', marginTop: '24px', paddingTop: '10px', borderTop: '1.5px solid #cbd5e1' },
  sigLine: { borderBottom: '1px solid #94a3b8', height: '36px', marginBottom: '3px' },
  sigLbl: { fontSize: '7px', color: '#64748b', textTransform: 'uppercase', textAlign: 'center' },
  footer: { marginTop: '12px', paddingTop: '6px', borderTop: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', fontSize: '7px', color: '#94a3b8' },
};

const PrintableToolList = ({ productCode, productName, revisionCode, tools }) => {
  if (!tools || tools.length === 0) return null;

  return (
    <div style={s.page} data-testid="printable-tool-list">
      {/* Header */}
      <div style={s.header}>
        <div>
          <div style={s.companyName}>EVOTECH</div>
          <div style={s.companySubtitle}>Lavorazioni Meccaniche di Precisione</div>
        </div>
        <div>
          <div style={s.docTitle}>LISTA UTENSILI</div>
          <div style={{ fontSize: '12px', fontWeight: '700', fontFamily: 'monospace', textAlign: 'right', marginTop: '2px' }}>
            {productCode} - Rev. {revisionCode}
          </div>
        </div>
      </div>

      {/* Product Info */}
      <div style={s.sectionTitle}>Prodotto</div>
      <div style={s.infoGrid}>
        <div><div style={s.lbl}>Codice Prodotto</div><div style={s.valMono}>{productCode}</div></div>
        <div><div style={s.lbl}>Descrizione</div><div style={s.val}>{productName}</div></div>
        <div><div style={s.lbl}>Revisione</div><div style={s.valBold}>{revisionCode}</div></div>
        <div><div style={s.lbl}>Data Stampa</div><div style={s.val}>{new Date().toLocaleDateString('it-IT')}</div></div>
      </div>

      {/* Tool List Table */}
      <div style={s.sectionTitle}>Lista Utensili</div>
      <table style={s.table}>
        <thead>
          <tr>
            <th style={{ ...s.th, width: '5%' }}>Seq.</th>
            <th style={{ ...s.th, width: '10%' }}>Codice</th>
            <th style={{ ...s.th, width: '18%' }}>Descrizione</th>
            <th style={{ ...s.th, width: '8%' }}>Categoria</th>
            <th style={{ ...s.th, width: '12%' }}>Fase</th>
            <th style={{ ...s.th, width: '9%' }}>Funzione</th>
            <th style={{ ...s.th, width: '5%' }}>Obbl.</th>
            <th style={{ ...s.th, width: '5%' }}>Crit.</th>
            <th style={{ ...s.th, width: '15%' }}>Note Setup</th>
            <th style={{ ...s.th, width: '13%' }}>Criterio Sostituz.</th>
          </tr>
        </thead>
        <tbody>
          {tools.map((rt, idx) => (
            <tr key={idx} style={rt.critical ? { background: '#fef2f2' } : {}}>
              <td style={{ ...s.td, ...s.tdMono, fontWeight: '700' }}>{rt.sequence}</td>
              <td style={{ ...s.td, ...s.tdMono, fontSize: '8px' }}>{rt.tool_code || '-'}</td>
              <td style={s.td}>{rt.tool_description || '-'}</td>
              <td style={{ ...s.td, fontSize: '8px' }}>{rt.category_name || '-'}</td>
              <td style={s.td}>{rt.phase_description || '-'}</td>
              <td style={s.td}>{rt.tool_function}</td>
              <td style={{ ...s.td, textAlign: 'center', fontWeight: '700' }}>{rt.mandatory ? 'SI' : '-'}</td>
              <td style={{ ...s.td, textAlign: 'center', fontWeight: '700', color: rt.critical ? '#dc2626' : '#64748b' }}>{rt.critical ? 'SI' : '-'}</td>
              <td style={{ ...s.td, fontSize: '8px' }}>{rt.setup_notes || '-'}</td>
              <td style={{ ...s.td, fontSize: '8px' }}>{rt.replacement_criteria || '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div style={{ marginTop: '8px', fontSize: '8px', color: '#64748b' }}>
        Totale utensili: {tools.length} | Critici: {tools.filter(t => t.critical).length} | Obbligatori: {tools.filter(t => t.mandatory).length}
      </div>

      {/* Signature Area */}
      <div style={s.sigArea}>
        <div><div style={s.sigLine} /><div style={s.sigLbl}>Preparato da</div></div>
        <div><div style={s.sigLine} /><div style={s.sigLbl}>Verificato da</div></div>
        <div><div style={s.sigLine} /><div style={s.sigLbl}>Data</div></div>
      </div>

      {/* Footer */}
      <div style={s.footer}>
        <span>Evotech S.r.l. - Lista Utensili generata il {new Date().toLocaleDateString('it-IT')}</span>
        <span>Pag. 1 di 1</span>
      </div>
    </div>
  );
};

export default PrintableToolList;
